import * as fromDatatype from '../datatype-library';

export interface bl_cms_widget_theme_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  widget_hdr_guid: fromDatatype.GuidDataFieldInterface;
  theme_hdr_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_cms_widget_theme_link_RowClass implements bl_cms_widget_theme_link_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  widget_hdr_guid: fromDatatype.GuidDataFieldInterface;
  theme_hdr_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
}
